<template>
  <v-dialog v-model="value" width="1000" persistent>
    <v-card color="green lighten-5 fill-height">
      <v-card-actions>
        <v-subheader>
          <i18n path="ticket.title" />
        </v-subheader>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form ref="form" :lazy-validation="true">
          <v-row>
            <v-col cols="12">
              <v-select
                :items="$t('ticket.types')"
                :label="$t('ticket.type')+'*'"
                v-model="item.typeid"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                shaped
                :disabled="$store.getters.test('tickets.a')"
                outlined
                @change="item.description=(item.description?item.description:'')+$t('ticket.types')[item.typeid].description"
              ></v-select>
            </v-col>
            <v-col cols="12" v-if="$store.getters.test('tickets.u')">
              <v-textarea
                v-model="item.description"
                :rules="[v =>(v && v.length<=4096) || $t('error.length')]"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')+'*'"
                clearable
                shaped
                outlined
                counter="4096"
                :label="$t('ticket.description')"
              ></v-textarea>
            </v-col>
            <v-col cols="12" v-if="$store.getters.test('tickets.a')">
              <div class="ticket-description pa-4 yellow lighten-5">{{item.description}}</div>
            </v-col>
            <v-col cols="12" v-if="$store.getters.test('tickets.a')">
              <v-textarea
                v-model="item.resume"
                :rules="[v => v==null || v.length<=4096 || $t('error.length')]"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')+'*'"
                clearable
                shaped
                outlined
                counter="4096"
                :label="$t('ticket.resume')"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-alert
                v-model="showAlert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                :dismissible="true"
                transition="fade-transition"
              >{{alertMessage}}</v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="$store.getters.test('tickets.a')">
        <v-btn
          v-if="$store.getters.test('tickets.a') && item.status==2 && item.idx"
          text
          @click="todraft"
        >{{$t('ticket.btn.todraft')}}</v-btn>
      </v-card-actions>
      <v-card-actions>
        <v-btn
          v-if="$store.getters.test('tickets.u') && item.status==0 && item.idx"
          color="error darken-1"
          text
          @click="deleteTicket"
        >{{$t('ticket.btn.delete')}}</v-btn>
        <v-btn
          v-if="$store.getters.test('tickets.a') && item.status==2 && item.idx"
          color="error darken-1"
          text
          @click="cancelTicket"
        >{{$t('ticket.btn.cancel')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="$store.getters.test('tickets.u')"
          color="blue darken-1"
          text
          @click="save"
        >{{$t('ticket.btn.save')}}</v-btn>
        <v-btn
          v-if="$store.getters.test('tickets.a')"
          color="blue darken-1"
          text
          @click="adminSave"
        >{{$t('ticket.btn.save')}}</v-btn>
        <v-btn
          v-if="$store.getters.test('tickets.u')"
          color="blue darken-1"
          text
          @click="start"
        >{{$t('ticket.btn.start')}}</v-btn>
        <v-btn
          v-if="$store.getters.test('tickets.a')"
          color="blue darken-1"
          text
          @click="complete"
        >{{$t('ticket.btn.complete')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import app from "@/app.js";

export default {
  name: "TicketRecord",
  props: {
    record: { type: Object, required: true },
    value: { type: Boolean },
  },
  data() {
    return {
      simpleDialog: false,
      showAlert: false,
      alertMessage: "",
      userRules: [(v) => !!v || this.$t("error.required")],
      item: { ...this.record },
    };
  },
  watch: {
    record: {
      handler(nv) {
        this.item = { ...nv };
        if (this.item.status == 1 && this.$store.getters.test("tickets.a")) {
          this.item.status = 2;
          app.setTicketStatus(this.item).then((response) => {
            if (!response.count) {
              this.showAlertMessage(this.$t("ticket.error"));
            }
          });
        }
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    close() {
      this.$emit("input", false);
    },
    cancelTicket(){
      this.item.status = 4;
      this.adminSave();
    },
    todraft(){
      this.item.status = 0;
      this.adminSave();
    },
    complete() {
      app.completeTicket(this.item).then((response) => {
        if (response.count) {
          this.$emit("refresh");
          this.$root.$emit("show_snack", {
            msg: this.$t("ticket.msg.completed"),
          });
          this.close();
        } else {
          this.showAlertMessage(this.$t("ticket.msg.error"));
        }
      });
    },
    deleteTicket() {
      app.deleteTicket(this.item).then((response) => {
        if (response.count) {
          this.$emit("refresh");
          this.$root.$emit("show_snack", {
            msg: this.$t("ticket.msg.deleted"),
          });
          this.close();
        } else {
          this.showAlertMessage(this.$t("ticket.msg.error"));
        }
      });
    },
    start() {
      this.item.status = 1;
      this.save();
    },
    save() {
      if (!this.$refs.form.validate()) return;
      app.upsertUserTicket(this.item).then((response) => {
        if (response.count) {
          this.$emit("refresh");
          this.$root.$emit("show_snack", {
            msg: this.$t("ticket.msg.saved"),
          });
          this.close();
        } else {
          this.showAlertMessage(this.$t("ticket.error"));
        }
      });
    },
    adminSave() {
      app.adminUpdateTicket(this.item).then((response) => {
        if (response.count) {
          this.$emit("refresh");
          this.$root.$emit("show_snack", {
            msg: this.$t("ticket.msg.saved"),
          });
          this.close();
        } else {
          this.showAlertMessage(this.$t("ticket.error"));
        }
      });
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    },
  },
};
</script>

<style scoped>
.last-modified {
  text-align: right;
}
.ticket-description{
  border-radius: 25px;
  border-style: ridge;
}
</style>